<template>
<!-- Site wrapper -->
  <div class="form-row">
    <div class="form-group col-md-12 col-xl-6">
      <label for="inputCoordenador" class="required">Coordenador</label>
      <v-select
        class="style-chooser"
        v-model="dadosPerfil.coordinator"
        @search="eventoDigitarBuscaPorCoordenador"
        :options="comboCoordenadoresDisponiveis"
        :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
        :filterable="false">
        <template v-slot:no-options>
          <em>Nenhum registro encontrado.</em>
        </template>
      </v-select>
      <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_profile_data.f_coordinator']}}</div>
    </div>
    <div class="agrupamento col-xl-12">
      <div class="form-row col-xl-12">
        <div class="form-group col-sm-12 col-md-12 col-lg-10 col-xl-11">
          <label for="inputCapas" class="mt-2">Capas</label>
          <v-select
            class="style-chooser"
            v-model="capaSelecionada"
            @search="eventoDigitarBuscaPorCapa"
            :options="comboCapasDisponiveis"
            :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
            :filterable="false">
            <template v-slot:no-options>
              <em>Nenhum registro encontrado.</em>
            </template>
          </v-select>
          <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_profile_data.f_capas']}}</div>
        </div>
        <div class="form-group text-right col-sm-12 col-md-12 col-lg-2 col-xl-1">
          <b-button class="botoes" style="margin-top: 2.6rem;" variant="outline-primary btn-sm" @click="adicionarNaListagemDeCapas()" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">Adicionar</b-button>
        </div>
        <default-table
          :items="dadosPerfil.f_capas"
          :fields="fieldsCapa"
          :busy="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
          :tbody-tr-class="tabelaSemRegistros">
          <template #empty>
            <em>Nenhum registro encontrado.</em>
          </template>
          <template #cell(opcoes)="row">
            <b-button class="botoes" variant="outline-danger btn-sm" title="Excluir" @click="excluirDaListagemDeCapas(row.item)" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
              <i class="fas fa-trash-alt"></i>
            </b-button>
          </template>
        </default-table>
      </div>
    </div>
  </div>
</template>

<script>
import Estagiario from '../layoutPerfil/js/estagiario'
export default Estagiario
</script>

<style scoped>
@import "../layoutPerfil/scss/estagiario.scss";
</style>
